import type { IANATimezoneIdentifier } from './types'

export function ensureValidTimeZoneIdentifier(
  timeZoneIdentifier: IANATimezoneIdentifier
) {
  // @note The locale is hardcoded to `'en-US'` because the locale is a
  //   required argument, but it has no effect on the validation.
  new Date().toLocaleString('en-US', { timeZone: timeZoneIdentifier })
}
